import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface VisitorState {
  currency: string
  exchangeRate: number
  currencyLoaded: boolean
  payment: {
    tag: string
  }
}

const initialState: VisitorState = {
  currency: '$',
  exchangeRate: 1,
  currencyLoaded: false,
  payment: {
    tag: ''
  }
}

const visitorSlice = createSlice({
  name: 'visitor',
  initialState,
  reducers: {
    setCurrency: (
      state,
      action: PayloadAction<{ currency: string; exchangeRate: number }>
    ) => ({
      ...state,
      currency: action.payload.currency,
      exchangeRate: action.payload.exchangeRate,
      currencyLoaded: true
    }),
    setPaymentTag: (state, action: PayloadAction<string>) => ({
      ...state,
      payment: {
        tag: action.payload
      }
    })
  }
})

export const { setPaymentTag, setCurrency } = visitorSlice.actions
export default visitorSlice.reducer
